(function () {
  const root = document.querySelector('[data-article-detail]');
  if (!root) return;

  const frame = root.querySelector('[data-article-media] .article-detail__media-frame');
  const video = root.querySelector('[data-article-video]');
  const playButton = root.querySelector('[data-article-play]');

  if (!frame || !video || !playButton) return;

  let firstFrameReady = false;

  function setPlaying(playing) {
    frame.classList.toggle('is-playing', playing);
    playButton.setAttribute('aria-hidden', playing ? 'true' : 'false');
    playButton.tabIndex = playing ? -1 : 0;
    video.controls = playing;
  }

  function primeFirstFrame() {
    if (firstFrameReady || frame.classList.contains('is-playing')) return;
    if (video.readyState < 1) return;

    firstFrameReady = true;

    const showFrame = () => {
      if (frame.classList.contains('is-playing')) return;
      try {
        if (video.currentTime < 0.001) {
          video.currentTime = 0.001;
        }
      } catch (e) {}
      video.pause();
      frame.classList.add('is-ready');
    };

    if (video.readyState >= 2) {
      showFrame();
      return;
    }

    video.addEventListener('seeked', showFrame, { once: true });
    try {
      video.currentTime = 0.001;
    } catch (e) {
      showFrame();
    }
  }

  function playVideo() {
    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(() => setPlaying(true))
        .catch(() => setPlaying(false));
    } else {
      setPlaying(true);
    }
  }

  video.addEventListener('loadedmetadata', primeFirstFrame);
  video.addEventListener('loadeddata', primeFirstFrame);
  if (video.readyState >= 1) primeFirstFrame();

  playButton.addEventListener('click', playVideo);

  video.addEventListener('play', () => setPlaying(true));
  video.addEventListener('playing', () => setPlaying(true));
  video.addEventListener('pause', () => {
    if (video.ended) return;
    setPlaying(false);
    primeFirstFrame();
  });
  video.addEventListener('ended', () => {
    setPlaying(false);
    firstFrameReady = false;
    try {
      video.currentTime = 0.001;
    } catch (e) {}
    primeFirstFrame();
  });
})();
